/*
 * Backbone Models used throughout the application.
 *
 * These models are translated direct from the JSON received by the Shopify API
 * endpoints.  For some reason the JSON received by the Shopify API verse the
 * JSON rendered by Shopify templates is different.
 *
 * @author Jonathon McDonald <jonathon@agencyfusion.com>
 * @author Rachel Wolthuis <rachel@agencyfusion.com>
 */
(function () {
  var Product = Backbone.Model.extend({
    url: function () {
      return '/products/' + this.get('handle') + '.json';
    },

    parse: function (response, options) {
      var product = response.product;

      if (!product.featured_image && product.image) {
        product.featured_image = product.image.src;
      }

      if (product.variants) {
        _.each(product.variants, function (variant) {
          // Set options array for variants.
          if (!variant.options) {
            variant.options = [];
            if (variant.option1) { variant.options.push(variant.option1); }
            if (variant.option2) { variant.options.push(variant.option2); }
            if (variant.option3) { variant.options.push(variant.option3); }
          }
        });
      }

      return response.product;
    }
  });

  /**
   * Represents the shopper's cart.
   */
  var Cart = Backbone.Model.extend({
    defaults: {
      total: 0,
      items: [],
      item_count: 0
    },

    /**
     * Adds a given product to the cart.
     *
     * Object is typically a hash with the variant id and the quantity.
     */
    addToCart: function (obj) {
      $.ajax({
        context: this,
        dataType: 'json',
        url: '/cart/add.js',
        type: 'POST',
        data: obj,
        success: this.successAddToCart,
        error: this.errorAddToCart
      });
    },

    debugError: function (data) {
      console.log("AJAX ERROR");
      console.log(data);
    },

    errorAddToCart: function (data) {
      this.trigger('add-to-cart:error', data);
    },

    initialize: function (attributes, options) {
      _.each(this.attributes.items, function (item, index) {
        this.attributes.items[index].title = this.sanitizeTitle(item.title);
      }, this);
    },

    loadAttributes: function () {
      var self = this;
      var goFetch = function (item, index) {
        var successful = function (data) {
          self.successFetchAttribute(data, index, item.id);
        };

        $.ajax({
          context: self,
          dataType: 'json',
          url: '/products/' + item.handle + '.js',
          type: 'GET',
          success: successful,
          error: this.debugError
        });
      };

      _.each(this.attributes.items, goFetch, this);
    },

    sanitizeTitle: function (title) {
      var str = title,
          split = str.split("-");

      split.pop();
      str = split.join("-");

      return str;
    },

    /**
     * Called when a cart is successfully updated.
     */
    successAddToCart: function (data) {
      
      this.attributes.total += data.price;
      this.attributes.items.unshift(data);
      this.attributes.item_count += data.quantity;


      var title = this.attributes.items[0].title;
      this.attributes.items[0].title = this.sanitizeTitle(title);

      this.trigger('add-to-cart:success', data);
      this.trigger('change');
      
    },

    /**
     * Called when an attribute has a product fully fetched.
     */
    successFetchAttribute: function (data, index, attrId) {
      if (attrId != this.attributes.items[index].id) {
        return;
      }

      var product = new App.Models.Product(data),
          helper = new App.Helpers.VariantPunnett(product),
          result = helper.getOptionsForVariant(attrId);

      this.attributes.items[index].selectedOptions = result;
      this.trigger('cart:attribute-fetch:success', attrId, result);
    }
  });

  window.App.Models.Product = Product;
  window.App.Models.Cart = Cart;
})();